// ============================================================================
// POLISH TRANSLATIONS - CHAPTER 8: POMOC NAJWYŻSZEGO (BONUS)
// ============================================================================
// Poziom 92 (1 poziom bonusowy, 3 pytania)

export const chapter8Translations = {
  name: "Pomoc Najwyższego",
  description: "Kto mieszka w ukryciu Najwyższego, w cieniu Wszechmocnego przebywać będzie",
  
  spiritualWisdom: {
    principle: "Dotarłeś na szczyt góry, a wiedza została zdobyta",
    scripture: "Kto mieszka w ukryciu Najwyższego, w cieniu Wszechmocnego przebywać będzie (Psalm 91:1)",
    application: "Niezachwiana wiara wymaga doświadczenia życiowego, miłosierdzia i prawdziwej miłości Jezusa. Próby sprawdzą twoje serce, prawdziwą wybraną drogę."
  },
  
  levels: {
    92: {
      name: "Ukrycie Najwyższego",
      challenge: "Jesteś na szczycie góry... Ale niezachwiana wiara zaczyna się teraz...",
      easy: {
        question: "Kim jest Jezus dla ciebie osobiście?",
        options: [
          "Zwykłym prorokiem",
          "Moim osobistym Panem i Zbawicielem",
          "Legendą",
          "Filozofem"
        ],
        hint: "On jest tym, który oddaje swoje życie, aby nas zbawić",
        funFact: "✝️ Jezus jest Bogiem! On nie jest tylko postacią historyczną - Jest żywy i pragnie osobistej relacji z każdym z nas!"
      },
      medium: {
        question: "Dlaczego post jak Daniela pozwala nam lepiej słyszeć Boga?",
        options: [
          "Aby schudnąć",
          "Aby pozbawić się tego, co kochamy i mieć przemienione serce",
          "Aby zrobić wrażenie na innych",
          "Aby być silniejszym"
        ],
        hint: "Pozbaw się tego, co najbardziej kochasz, w ciszy i mądrości",
        funFact: "🙏 Post duchowy przygotowuje nasze serce na głębokie przemiany - często bolesne - które przybliżają nas do Boga!"
      },
      hard: {
        question: "Jaka jest prawdziwa odpowiedź serca wobec całej tej zdobytej wiedzy?",
        options: [
          "Teraz jestem doskonały",
          "Daję Ci moje serce Jezu i pragnę być ochrzczony",
          "Wiem lepiej niż inni",
          "Nie potrzebuję już pomocy"
        ],
        hint: "Prawdziwa wiara prowadzi do całkowitego oddania i zaangażowania w Jezusa",
        funFact: "🌟✨ Dotarłeś na szczyt góry, a wiedza została zdobyta ✨\n\n💖 Niezachwiana wiara wymaga doświadczenia życiowego, miłosierdzia i prawdziwej miłości Jezusa 💖\n\n🔥 Różne próby życia sprawdzą twoją drogę, prawdziwą ścieżkę, którą wybieramy, nasze serce 🔥\n\n😔 Pozostajemy niedoskonali, nasze pragnienia są liczne, a miłość do zysku lub naszego osobistego komfortu zbyt często staje się naszym egoistycznym priorytetem 😔\n\n🙏 Proś Boga o mądrość, Jego miłość, Jego moc i pokornie uznaj swoje słabości, bo nie możemy ukryć przed Nim niczego... Niczego 🙏\n\n🥖 Pość jak Daniel: pozbaw się na chwilę tego, co najbardziej kochasz, w ciszy i mądrości 🥖\n\n💫 To pozwoli ci lepiej słyszeć Boga, mieć dyspozycję serca gotową na głębokie przemiany 💫\n\n🌙 Wtedy sny i wizje staną się jaśniejsze, jak u Józefa 🌙\n\n⚠️ Strzeż się pychy: nie ulegaj 'zawsze mam rację' lub 'wiem lepiej' ⚠️\n\n🎁 Bo objawienie Boże jest nadzwyczajną łaską 🎁\n\n💝 Mieć wiarę to wejść w relację i wolną drogę serca 💝\n\n🦸‍♂️ Uczyni cię potężnymi bohaterami, zdolnymi do niemożliwego 🦸‍♂️\n\n✝️ Na szczycie wiedzy szczere serce mówi: 'Daję Ci moje serce Jezu i pragnę być ochrzczony' ✝️\n\n🏔️ Dotarłeś na szczyt góry, trzymaj się mocno, wytrwaj! 🏔️\n\n⬇️ Trzeba zejść i nieść ten cenny skarb: nadzieję życia wiecznego ⬇️\n\n🏆✨ BRAWO! JESTEŚMY Z CIEBIE DUMNI ✨🏆\n🌟 ODWAGA DZIELNY NIOSĄCY POKÓJ 🌟\n🕊️✨ NIECH BÓG CIĘ BŁOGOSŁAWI ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
